// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"fb8afec4","453":"6319366f","902":"991d2a5b"}[chunkId] + ".chunk.js";
};